import {useSettings as useYoshiSettings} from '@wix/tpa-settings/react'
import type {ISettingsParam, ISettingsSetter} from '@wix/tpa-settings'
import {useSettingsBi, WidgetType} from '../../../settings-commons/hooks/use-settings-bi'

export const useSettings = componentSettings => {
  const settings = useYoshiSettings()
  const {debouncedEditorEventsWidgetSettingChanged} = useSettingsBi(WidgetType.EventsWidget)

  const legacyValue = (param: ISettingsParam) => componentSettings.texts[param.key] || componentSettings[param.key]

  const get = (param: ISettingsParam) => {
    const value = settings.get(param)
    return value ?? legacyValue(param)
  }

  const getWithFallback = (param: ISettingsParam, fallbackParam: ISettingsParam) => {
    const value = settings.get(param)
    const fallbackValue = settings.get(fallbackParam)
    return value ?? fallbackValue ?? legacyValue(param) ?? legacyValue(fallbackParam)
  }

  const set: ISettingsSetter = (param, value) => {
    debouncedEditorEventsWidgetSettingChanged(param.key, value)
    settings.set(param, value)
  }

  return {
    ...settings,
    get,
    getWithFallback,
    set,
  }
}
